import ConfigProvider from "antd/lib/config-provider";
import antTheme from "antd/lib/theme";
import { createContext, ReactNode, useContext, useState } from "react";

import { Moon01 } from "@sol/uikit/core/icons/Weather/Moon01";
import { Sun02 } from "@sol/uikit/core/icons/Weather/Sun02";
import { Switch } from "@sol/uikit/data-entry/Switch/Switch";
import { themeConfig } from "@sol/uikit/theming";

type AppThemeProviderProps = {
    darkMode?: boolean;
    children: ReactNode;
};
export function AppThemeProvider({ children, darkMode }: AppThemeProviderProps) {
    const [enableDarkMode, setEnableDarkMode] = useState(darkMode ?? false);

    const isDark = darkMode ?? enableDarkMode;

    return (
        <darkModeCtx.Provider value={{ darkMode: isDark, setDarkMode: setEnableDarkMode }}>
            <ConfigProvider theme={isDark ? { ...themeConfig, algorithm: antTheme.darkAlgorithm } : themeConfig}>
                {children}
            </ConfigProvider>
        </darkModeCtx.Provider>
    );
}

const darkModeCtx = createContext<{ darkMode: boolean; setDarkMode: (darkMode: boolean) => void }>({
    darkMode: false,
    setDarkMode: () => {},
});

export function DarkModeSwitch() {
    const { darkMode, setDarkMode } = useContext(darkModeCtx);
    return (
        <Switch
            checked={darkMode}
            onChange={setDarkMode}
            size="default"
            checkedChildren={
                <span className="flex h-(--ant-switch-track-height) items-center">
                    <Moon01 variant="antd" />
                </span>
            }
            unCheckedChildren={
                <span className="flex h-(--ant-switch-track-height) items-center">
                    <Sun02 variant="antd" />
                </span>
            }
        />
    );
}
